import credits from './credits.json'

// Every image in src/assets/images, keyed by file name (without extension).
// Structural data only (file, dimensions, credit) – alt text and captions are
// translated per language in src/i18n/content and merged in by usePhotos().
const files = import.meta.glob('../assets/images/*.jpg', { eager: true, import: 'default' })

// area: which "Explore" guide the photo belongs to (used by the gallery filter)
const areas = {
  'village-minaret': 'nanovitsa',
  'village-sign': 'nanovitsa',
  'village-view': 'nanovitsa',
  'village-road': 'nanovitsa',
  'village-signpost': 'nanovitsa',
  'tatul-panorama': 'tatul',
  'tatul-niche': 'tatul',
  'tatul-summit': 'tatul',
  'tatul-rock-niche': 'tatul',
  'tatul-sanctuary': 'tatul',
  'tatul-excavation': 'tatul',
  'momchilgrad-square': 'momchilgrad',
  'momchilgrad-center': 'momchilgrad',
  'kardzhali-museum': 'kardzhali',
  'kardzhali-view': 'kardzhali',
  'kardzhali-reservoir': 'region',
  'perperikon-top': 'region',
  'perperikon-walls': 'region',
  'perperikon-complex': 'region',
  'stone-mushrooms': 'region',
  'stone-mushrooms-dusk': 'region',
  'studen-kladenets-dam': 'region',
}

export const basePhotos = Object.fromEntries(
  Object.keys(areas).map((id) => [
    id,
    { id, src: files[`../assets/images/${id}.jpg`], area: areas[id], ...credits[id] },
  ]),
)

export const galleryFilterIds = ['all', 'nanovitsa', 'tatul', 'momchilgrad', 'kardzhali', 'region']
